import { ThankYouEmailForm } from './ThankYouEmailForm';
export default ThankYouEmailForm;
